// Bowers Advisory Group — brand constants
export const CALENDLY_URL = 'https://calendly.com/anthonybowers1988/30min';

export const BRAND = {
  name: 'Bowers Advisory Group',
  short: 'BAG',
  tagline: 'Protect What Matters. Build What\'s Next. Leave a Lasting Legacy.',
  founder: 'Anthony Bowers',
  founderTitle: 'Founder & Financial Consultant',
  phone: '(661) 802-3486',
  phoneHref: 'tel:+16618023486',
  email: 'legacy@bowersadvisorygroup.org',
  emailHref: 'mailto:legacy@bowersadvisorygroup.org',
  website: 'bowersadvisorygroup.org',
  websiteHref: 'https://bowersadvisorygroup.org',
};

export const LICENSING = {
  residentState: 'California',
  residentLicense: '0I19627',
  states: ['California', 'Texas', 'Nevada'],
  statesShort: 'CA · TX · NV',
};

export const ASSETS = {
  logoStackedDark: 'https://customer-assets.emergentagent.com/job_wealth-legacy-7/artifacts/d8vj4jyk_Screenshot%202026-06-30%20at%2012.01.27%E2%80%AFPM.png',
  logoStackedLight: 'https://customer-assets.emergentagent.com/job_wealth-legacy-7/artifacts/rrxeh1n4_Screenshot%202026-06-30%20at%2011.21.49%E2%80%AFAM.png',
  logoHorizontal: 'https://customer-assets.emergentagent.com/job_wealth-legacy-7/artifacts/7nol37v7_Screenshot%202026-06-30%20at%2011.22.06%E2%80%AFAM.png',
  monogramDark: 'https://customer-assets.emergentagent.com/job_wealth-legacy-7/artifacts/l4g0y3oh_Screenshot%202026-06-30%20at%2012.21.20%E2%80%AFPM.png?v=2',
  founderHeadshot: 'https://customer-assets.emergentagent.com/job_wealth-legacy-7/artifacts/6a9enedu_Headshot.JPG',
};

export const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Who We Serve', href: '#who-we-serve' },
  { label: 'Framework', href: '#framework' },
  { label: 'Services', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];

export const AUDIENCES = [
  {
    key: 'families',
    title: 'Families',
    copy: 'Protect income, prepare for the unexpected, and create a foundation for the next generation.',
    icon: 'home',
    image: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1200&q=80',
  },
  {
    key: 'educators',
    title: 'Educators',
    copy: 'Translate financial complexity into clear, practical strategies for retirement, protection, and long-term security.',
    icon: 'book',
    image: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=1200&q=80',
  },
  {
    key: 'business',
    title: 'Business Owners',
    copy: 'Coordinate protection, continuity, retirement strategies, and legacy planning around the business you are building.',
    icon: 'briefcase',
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1200&q=80',
  },
  {
    key: 'churches',
    title: 'Churches & Faith Communities',
    copy: 'Support stewardship, protection, and financial education for leaders, families, and communities of faith.',
    icon: 'church',
    image: 'https://images.unsplash.com/photo-1507692049790-de58290a4334?auto=format&fit=crop&w=1200&q=80',
  },
];

export const FRAMEWORK = [
  { num: '01', title: 'Protect', copy: 'Safeguard your family, income, and future.' },
  { num: '02', title: 'Build', copy: 'Strengthen your financial foundation with intentional strategies.' },
  { num: '03', title: 'Preserve', copy: 'Prepare for retirement and reduce unnecessary uncertainty.' },
  { num: '04', title: 'Leave', copy: 'Create a legacy that reflects your values and supports future generations.' },
];

export const SERVICES = [
  { title: 'Retirement Planning', copy: 'Thoughtful retirement strategies designed around your timeline, income needs, and long-term goals.', icon: 'landmark' },
  { title: 'Life Insurance', copy: 'Protection strategies that safeguard the people who depend on you — today and for decades to come.', icon: 'shield' },
  { title: 'Annuities', copy: 'Insurance based strategies that help create predictable income streams for retirement.', icon: 'trending-up' },
  { title: 'Rollovers', copy: 'Guidance through 401(k), IRA, and pension transitions with clarity and care.', icon: 'repeat' },
  { title: 'Estate & Legacy Planning', copy: 'Coordinate protection, transfer, and legacy strategies aligned with your values.', icon: 'scroll' },
  { title: 'Financial Education', copy: 'One-on-one and group education so every decision is understood — not just made.', icon: 'graduation-cap' },
];

export const PILLARS = [
  {
    title: 'Education Before Execution',
    copy: 'Every strategy begins with understanding. We take the time to explain the "why" before recommending the "what," so decisions feel informed and clear.',
    icon: 'lightbulb',
  },
  {
    title: 'Strategy Before Product',
    copy: 'We do not lead with products. We lead with a strategy shaped by your life, your family, and your values — and only then consider the tools that fit.',
    icon: 'compass',
  },
  {
    title: 'Legacy Before Transaction',
    copy: 'This is not a transaction. It is a long-term relationship centered on the legacy you are building for the people you love.',
    icon: 'crown',
  },
];

export const TESTIMONIALS = [
  {
    quote: 'When my husband was diagnosed, we suddenly had to look at every part of our plan differently. Anthony sat with us. He listened first — really listened — and then quietly rebuilt the strategy around what was actually at stake. It never felt like a meeting. It felt like a conversation between people who cared about the same thing.',
    author: 'Karen & David',
    role: 'Family clients · Married 27 years',
  },
  {
    quote: 'I had three retirement accounts from three different jobs and did not understand any of them. Anthony walked me through each one, in plain English, at my kitchen table. For the first time, I could see what I actually had — and what I still needed. That clarity gave me back years of peace.',
    author: 'Marcus',
    role: 'Educator · California',
  },
  {
    quote: 'As a small business owner, everything went into the business — and almost nothing into protecting the people I built it for. Anthony helped me build a plan that honored both. It was the first time someone treated my family and my company as one story instead of two.',
    author: 'Renata',
    role: 'Business Owner · Family of four',
  },
];

export const INTEREST_OPTIONS = [
  'Retirement Planning',
  'Life Insurance',
  'Annuities',
  'Rollovers (401k / IRA / Pension)',
  'Estate & Legacy Planning',
  'Financial Education',
  'I am not sure — I would like to learn more',
];

export const DISCLAIMER = "Bowers Advisory Group provides financial education, insurance-based strategies, and consulting services. Services and product availability may vary by license, carrier, and state requirements. This site is for informational purposes only and does not constitute legal, tax, investment, or financial advice. No guarantees are made regarding financial outcomes.";
